import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=c4f2b782&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=c4f2b782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f2b782",
  null
  
)

export default component.exports